import { render, staticRenderFns } from "./DiscoverPage.vue?vue&type=template&id=0822e39a&scoped=true&"
import script from "./DiscoverPage.vue?vue&type=script&lang=js&"
export * from "./DiscoverPage.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverPage.vue?vue&type=style&index=0&id=0822e39a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0822e39a",
  null
  
)

export default component.exports